export function getPortraitImage(profile:any) {
  let image = profile ? profile.portrait : null;
  if(!image)
    return '/portrait-default.png';
  else
    return image;
}

export function getBannerImage(profile:any) {
  let image = profile ? profile.banner : null;
  if(!image)
    return '/banner-default.png';
  else
    return image;
}

